import styled from '@emotion/styled';

interface MatterportBlockZetaProps {
	url: string;
	index?: number;
}

const Wrapper = styled.section`
	padding: 3rem 1.5rem 4rem;
	background: #f5f5f5;
`;

const Title = styled.h2`
	text-transform: uppercase;
	font-size: 2rem;
	margin-bottom: 1.5rem;
`;

const Frame = styled.iframe`
	width: 100%;
	aspect-ratio: 16 / 9;
	border: none;
`;

export default function MatterportBlockZeta({ url, index }: MatterportBlockZetaProps) {
	return (
		<Wrapper id={index == null ? 'media' : undefined}>
			<Title>3D Tour</Title>
			<Frame src={url} allowFullScreen allow="xr-spatial-tracking" />
		</Wrapper>
	);
}
